<template>
  <jd-dialog
    :title="`${titleText}变更`"
    :visible.sync="isShow"
    width="450px"
    @close="handleClose"
    @confirm="handleconfirm"
  >
    <div class="new-input-box">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item :label="`${searchGrayId}：`" required>
          <el-input v-model="form.pin" :placeholder="`请输入${searchGrayId}`"></el-input>
        </el-form-item>
        <el-form-item :label="unitText" prop="giveTimes" required>
          <el-input-number v-model="form.giveTimes"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
  </jd-dialog>
</template>

<script>
import { saveGameTaskRecord } from "@/api/jhk/integralCenter/PointActivityAnalyticController";
export default {
  props: {
    activityId: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "抽奖次数",
    },
    unitText: {
      type: String,
      default: "变更次数",
    }
  },
  data() {
    return {
      rules: {
        pin: [{ required: true, message: "请输入用户PIN", trigger: "blur" }],
        giveTimes: [
          { required: true, message: "请输入变更次数", trigger: "blur" },
        ],
      },
      isShow: true,
      form: {
        pin: "",
        giveTimes: 0,
      },
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    handleconfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            activityId: this.activityId,
            giveTimes: this.form.giveTimes,
          }
          if(this.searchGrayId == 'xid'){
            params.xid = this.form.pin
          }
          else{
            params.pin = this.form.pin
          }
          saveGameTaskRecord(params).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: "变更成功",
                type: "success",
              });
              this.$emit("close", true);
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.form.pin = "";
    this.form.number = 0;
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input-number--small {
  line-height: 28px;
}
</style>
